import script from "./OnboardingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingPage.vue?vue&type=style&index=0&id=5eb012dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb012dc"]])

export default __exports__